import axios from "~/plugins/axios";

export default {
  getByAFDMessageId(afdMessageId) {
    return axios.get(`/web_api/v1/afd_message/${afdMessageId}/sivi_message`).then((response) => response.data);
  },
  getByPolicyId(policyId) {
    return this.getByEntity("App\\Models\\Policies", policyId);
  },
  getByEntity(entityType, entityId) {
    return axios.post("/web_api/v1/afd_message/sivi_message/by_entity", {
      entity_class: entityType,
      entity_id: entityId,
    }).then((response) => response.data);
  },
  processMessages(customerId,
    packageMessageId,
    packageMessageChosenPackageId,
    groupedMessages,
    linkGroupedMessages,
    newCustomerData,
    redirect,
    howToProcess,
    linkAttachmentsToAgencyCategory) {
    return axios.post("/afd/process", {
      customer_id: customerId,
      package_message_id: packageMessageId,
      package_message_chosen_package_id: packageMessageChosenPackageId,
      grouped_messages: groupedMessages,
      link_grouped_messages: linkGroupedMessages,
      new_customer_data: newCustomerData,
      redirect,
      how_to_process: howToProcess,
      link_attachments_to_agency_category: linkAttachmentsToAgencyCategory,
    });
  },
};
